import { Modal } from '@workramp/ui';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  .tox.tox-silver-sink.tox-tinymce-aux {
    z-index: 9;
  }
`;

export const StyledModal = styled(Modal)`
  width: 100%;
  max-width: 80vw;
`;

export const VersionContentWrapper = styled.div`
  height: 70vh;
  overflow: auto;
  border-right: 1px solid ${({ theme }) => theme.colors.on[100]};
  padding-right: ${({ theme }) => theme.spacing(6)}px;
  box-sizing: border-box;
`;

export const VersionHistoryWrapper = styled.div`
  height: 100%;
  overflow: auto;
`;
